var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1330_7890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2451 9.17935C36.2345 9.08497 36.1239 8.23999 35.5489 7.66562L29.084 1.20135C28.5096 0.62698 27.6646 0.515107 27.5709 0.504482C27.5471 0.501982 27.5234 0.500732 27.4996 0.500732H9.37491C7.65181 0.500732 6.24996 1.90259 6.24996 3.62568V14.8755H5.62497C4.59124 14.8755 3.75 15.7167 3.75 16.7505V24.2504C3.75 25.2841 4.59124 26.1253 5.62497 26.1253H6.24996V37.3752C6.24996 39.0983 7.65181 40.5001 9.37491 40.5001H33.1245C34.8476 40.5001 36.2495 39.0983 36.2495 37.3752V9.2506C36.2495 9.22622 36.2482 9.2031 36.2451 9.17935Z",
    fill: "url(#paint0_linear_1330_7890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1247 14.8755H5.62497C4.59124 14.8755 3.75 15.7167 3.75 16.7505V24.2503C3.75 25.2841 4.59124 26.1253 5.62497 26.1253H23.1247C24.1584 26.1253 24.9997 25.2841 24.9997 24.2503V16.7505C24.9997 15.7161 24.1591 14.8755 23.1247 14.8755Z",
    fill: "url(#paint1_linear_1330_7890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5488 7.66551L29.0839 1.20124C28.5095 0.626873 27.6645 0.515 27.5707 0.504375C27.3945 0.483125 27.217 0.54 27.0833 0.659373C26.9508 0.777496 26.8745 0.946868 26.8745 1.12562V6.75053C26.8745 8.47363 28.2764 9.87548 29.9995 9.87548H35.6244C35.8025 9.87548 35.9725 9.79923 36.0906 9.66673C36.2087 9.53361 36.265 9.35674 36.245 9.17986C36.235 9.08487 36.1237 8.23988 35.5488 7.66551Z",
    fill: "url(#paint2_linear_1330_7890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37497 17.3752H8.12499C7.77937 17.3752 7.5 17.6552 7.5 18.0002V23.0002C7.5 23.3452 7.77937 23.6251 8.12499 23.6251C8.47061 23.6251 8.74998 23.3452 8.74998 23.0002V21.7502H9.37497C10.4087 21.7502 11.2499 20.9089 11.2499 19.8752V19.2502C11.2499 18.2159 10.4093 17.3752 9.37497 17.3752ZM9.99996 19.8752C9.99996 20.2196 9.71997 20.5002 9.37497 20.5002H8.74998V18.6252H9.37497C9.71997 18.6252 9.99996 18.9058 9.99996 19.2502V19.8752Z",
    fill: "url(#paint3_linear_1330_7890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6247 19.8752H18.7497V18.6252H20.6247C20.9703 18.6252 21.2497 18.3452 21.2497 18.0002C21.2497 17.6552 20.9703 17.3752 20.6247 17.3752H18.1247C17.7791 17.3752 17.4998 17.6552 17.4998 18.0002V23.0002C17.4998 23.3452 17.7791 23.6251 18.1247 23.6251C18.4704 23.6251 18.7497 23.3452 18.7497 23.0002V21.1252H20.6247C20.9703 21.1252 21.2497 20.8452 21.2497 20.5002C21.2497 20.1552 20.9703 19.8752 20.6247 19.8752Z",
    fill: "url(#paint4_linear_1330_7890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 17.3752H13.125C12.7794 17.3752 12.5 17.6552 12.5 18.0002V23.0002C12.5 23.3452 12.7794 23.6251 13.125 23.6251H14.375C15.4087 23.6251 16.2499 22.7839 16.2499 21.7502V19.2502C16.2499 18.2159 15.4093 17.3752 14.375 17.3752ZM15 21.7502C15 22.0945 14.72 22.3752 14.375 22.3752H13.75V18.6252H14.375C14.72 18.6252 15 18.9058 15 19.2502V21.7502Z",
    fill: "url(#paint5_linear_1330_7890)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1330_7890",
    x1: 4.66686,
    y1: 37.0833,
    x2: 34.817,
    y2: 6.93315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1330_7890",
    x1: 6.79995,
    y1: 28.0753,
    x2: 21.9503,
    y2: 12.9249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2488FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1330_7890",
    x1: 27.7914,
    y1: 8.95862,
    x2: 32.3169,
    y2: 4.43306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00969B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1330_7890",
    x1: 6.43314,
    y1: 22.192,
    x2: 10.7006,
    y2: 17.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1330_7890",
    x1: 16.4329,
    y1: 22.192,
    x2: 21.0666,
    y2: 17.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1330_7890",
    x1: 11.875,
    y1: 22.6333,
    x2: 16.1418,
    y2: 18.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1330_7890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ead85cf38a589abe35d7d7d4bcd33551.svg";
export { ForwardRef as ReactComponent };